import type { ProductHitPrice } from '@libs/algolia';
import { productPriceMapper } from '@app/pdp/components/ProductPrice/utils';
import { useMemo } from 'react';
import type { ProductPrice } from '@app/pdp/components/ProductPrice';

export const useProductPriceMapper = (productPrice: ProductHitPrice) =>
    useMemo(
        (): ProductPrice => productPriceMapper(productPrice),
        [productPrice]
    );
